import React from 'react';
import ReactDOM from 'react-dom/client';
import { AgendateApp } from './AgendateApp';
import './css/index.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AgendateApp />
);
